import { checkIsCrosshairShareCode, checkIsInviteCode } from '_lib/utils/utils'
import EventBus from '_lib/EventBus'
import { checkLoginStatusAsync } from "_lib/utils/utils";
import { getCrosshairShareCodeInfo } from '_api/miniprogram';

export async function listenClipboard() {
  // 初始化请求客户端剪切板 & 监听focus时剪切板内容更新
  if (process.env.IS_CLIENT && window.electronAPI) {
    let content = await window.electronAPI.clipboardReadText()
    handleClpboardContent(content)
    window.electronAPI.onClipboardContent((_, content) => {
      handleClpboardContent(content)
    })
  }
}

async function handleClpboardContent (content) {
  if (content) {
    const isLogin = await checkLoginStatusAsync()
    // 先尝试正则获取邀请码
    let invite_code = await checkIsInviteCode(content)
    if (invite_code) {
      console.log(1, "Invite code: " + invite_code)
      let used = await window.electronAPI.checkInviteCodeUsed(invite_code)
      if (!used && isLogin) {
        EventBus.$dynamic('InvitedDialog', {invite_code})
        window.electronAPI.setInviteCodeUsed(invite_code)
      }
    }

    // 在尝试正则获取准星分享码
    let share_code = checkIsCrosshairShareCode(content);
    if (share_code) {
      console.log(2, 'Share code: ' + share_code);
      const realShareCode = share_code.split('ch')[1];
      if (realShareCode) {
        let used = await window.electronAPI.checkInviteCodeUsed(share_code);
        if (!used && isLogin) {
          window.electronAPI.setInviteCodeUsed(share_code)
          const {
            data: { status, result },
          } = await getCrosshairShareCodeInfo({
            share_code: realShareCode,
            _notip: 1,
          });

          if (status === 'ok') {
            const { share_info } = result;
            share_info['share_code'] = realShareCode
            EventBus.$dynamic('CrosshairShareDialog', { share_info });
          }
        }
      }
    }
  }
}
